const showLessModular = () => {
	const isModularPage = window.location.pathname.includes(
		'mila-villa-the-modular-designs',
	);
	const itemsPerPage = isModularPage ? 8 : 4;

	const section = document.querySelector('.modular-loader .mi-loop_modular');
	const loop = section?.querySelector(
		'.modular-loader .elementor-loop-container',
	);
	const showMoreBtn = document.querySelector(
		'.modular-loader .show-more-btn',
	);
	const showLessBtn = document.querySelector(
		'.modular-loader .show-less-btn',
	);

	if (!section || !loop || !showMoreBtn || !showLessBtn) return;

	const items = Array.from(
		loop.querySelectorAll('.mi-loop_modular .house-type'),
	);
	const totalItems = items.length;

	let currentVisible = itemsPerPage; // Track how many items are displayed

	// Hide buttons if total less than itemsPerPage
	if (totalItems <= itemsPerPage) {
		showMoreBtn.style.display = 'none';
		showLessBtn.style.display = 'none';
		return;
	}

	if (isModularPage) {
		showMoreBtn.style.display = 'inline-block';
	}

	// Initial state, show first 4
	const refreshView = () => {
		items.forEach((item, index) => {
			item.style.display = index < currentVisible ? '' : 'none';
		});
	};

	refreshView();

	// Show More Click → show +4 more
	showMoreBtn.addEventListener('click', () => {
		currentVisible += itemsPerPage; // Add 1-4 more

		if (currentVisible >= totalItems) {
			currentVisible = totalItems;
			showMoreBtn.style.display = 'none';
			showLessBtn.style.display = 'inline-block';
		}

		refreshView();
	});

	// Show Less Click, back to 4 items
	showLessBtn.addEventListener('click', () => {
		currentVisible = itemsPerPage;
		refreshView();

		showLessBtn.style.display = 'none';
		showMoreBtn.style.display = 'inline-block';

		// Scroll back to the loop section (more reliable than offsetTop)
		const headerOffset = 400;
		const elementTop =
			section.getBoundingClientRect().top + window.pageYOffset;
		window.scrollTo({
			top: Math.max(0, elementTop - headerOffset),
			behavior: 'smooth',
		});
	});
};

try {
	showLessModular();
} catch (err) {
	console.error(err);
}
